const FilterOptions = (e) => {
    let filterKey = {}
    const fieldName = e.target.getAttribute("name")
    let updatedValue = {};
    if(e.target.value.trim().length === 0) {
        delete filterKey[fieldName]
    }
    updatedValue[fieldName] = e.target.value.trim()
    filterKey = {...filterKey, ...updatedValue};
    return filterKey
}
export default FilterOptions